import styled, { css } from 'styled-components';

export const Container = styled.div`
  display: flex;
  z-index: 5;
  position: relative;
`;

export const Content = styled.div`
  width: 16.471875rem;
  /* height: 16.706875rem; */

  user-select: none;
  background: #585e66;
  position: absolute;
  margin-top: 1rem;
  border-radius: 0.2rem;

  top: 100%;
  right: 0.2rem;

  &:before {
    content: '';

    position: absolute;
    top: -0.7rem;
    right: 0.5rem;
    display: block;

    border-left: 0.5rem solid transparent;
    border-right: 0.5rem solid transparent;
    border-bottom: 1rem solid #585e66;
  }
`;
export const Button = styled.button`
  background: #d6ffee;
  border-radius: 50%;
  width: 2.470625rem;
  height: 2.470625rem;
  border: none;
  display: flex;
  align-items: center;
  justify-content: center;

  cursor: pointer;

  svg {
    width: 0.765rem;
    height: 1.646875rem;
  }

  path {
    fill: #118052;
  }

  ${({ help }) =>
    help &&
    css`
      background: #40e5a0;
      path {
        fill: #585e66;
      }
    `}
`;

export const TipsHeader = styled.div`
  display: flex;
  flex-direction: column;
  font-family: Sora;
  margin-left: 1.765rem;
  width: 100%;
  line-height: 1.334375rem;
`;

export const Tips = styled.span`
  color: #fff;
  margin-top: 1.765rem;
  font-size: 1.05875rem;
  font-weight: 600;
`;

export const HelpFlow = styled.span`
  color: #d4d6da;
  margin-top: 0.529375rem;
  font-size: 0.705625rem;
  line-height: 0.889375rem;
`;

export const Line = styled.div`
  width: 100%;
  height: 1px;
  background: #7e858f;

  margin-top: 1.235625rem;
`;

export const About = styled.div`
  width: 100%;
  //  height: 4.411875rem;
  display: flex;
  align-items: center;

  padding: 0.5rem 0rem;

  &:hover {
    background: #42464c;
    p {
      color: #eff1f5;
    }
  }

  svg {
    margin-left: 1.1rem;
    width: 3.2175rem;
    cursor: pointer;
  }
`;

export const AboutContent = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1rem;
  cursor: pointer;

  span {
    font-size: 0.82375rem;
    color: #40e5a0;
    line-height: 1.0375rem;
  }

  p {
    font-size: 0.70625rem;
    width: 90%;
    color: #a9aeb4;
  }
`;

export const Hotkeys = styled.div`
  width: 100%;
  display: flex;
  align-items: center;

  padding: 0.5rem 0rem;
  &:hover {
    background: #42464c;
    border-radius: 0 0 0.2rem 0.2rem;
    p {
      color: #eff1f5;
    }
  }

  svg {
    margin-left: 1.1rem;
    width: 3.2175rem;
    cursor: pointer;
  }
`;

export const HotkeysSection = styled.div`
  display: flex;
  flex-direction: column;
  margin-left: 1.765rem;
  padding-bottom: 1.765rem;
`;

export const Tip = styled.div`
  display: flex;
  margin-top: 1.105833rem;
  align-items: center;

  h1 {
    margin: 0 0.77375rem 0 0.77375rem;
    color: #40e5a0;
  }

  text {
    margin: 0 0 0 0.77375rem;
    color: #40e5a0;
    font-size: 0.8083rem;
    font-weight: 600;
  }

  svg {
    height: 2.458rem;
  }
`;

export const AboutSection = styled.div`
  display: flex;
  flex-direction: column;
  padding-bottom: 1.765rem;
  overflow-y: auto;
`;

export const SubSection = styled.div`
  display: flex;
  flex-direction: column;
  margin: 0.925rem 0 0 1.765rem;
`;

export const SectionTitle = styled.span`
  font-family: Sora;
  font-weight: 600;
  font-size: 0.8235875rem;
  line-height: 1.0625rem;
  color: #eff1f5;
  margin-bottom: 0.5rem;
`;

export const Description = styled.p`
  font-size: 0.70593125rem;
  line-height: 1.0625rem;
  width: 80%;

  color: #a9aeb4;
`;

export const Image = styled.img`
  width: 12.94rem;
  height: 7.059375rem;
`;
